<template>
  <div id="page_app">
    <Tester v-if="soon === true" />

    <v-card class="mt-4" v-else>
      <v-dialog v-model="modal_aktivasi" persistent width="500">
            <v-card>
                <v-toolbar color="primary" dark flat dense cad>
                    <v-toolbar-title class="subheading">Update URL Module Sidompul</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="openCloseModal()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="text-xs-left">
                    <v-form ref="form" lazy-validation @submit.prevent>
                        <v-col cols="12" md="12 ">
                            <v-text-field label="URL Sidompul" name="url" v-model="url"></v-text-field>
                        </v-col>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text dark @click="openCloseModal" color="red">Tutup</v-btn>
                    <v-btn text dark @click="ajukan" color="green">Update</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

      <v-data-table
        :headers="complex.headers"
        :items="sidompuls"
        class="elevation-1"
        item-key="id"
        :loading="loading"
        :options.sync="opsi"
        :server-items-length="totaldata"
        :hide-default-footer="true"
      >
        <template v-slot:progress>
          <v-skeleton-loader
            v-if="loading"
            transition="fade-transition"
            type="table-tbody"
          >
          </v-skeleton-loader>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="text-xs-left">
            <v-chip
              v-if="item.status === 1"
              color="green"
              small
              text-color="white"
              >{{ statusformat(item.status) }}</v-chip
            >
            <v-chip v-else color="ongoing" small>{{
              statusformat(item.status)
            }}</v-chip>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="text-xs-left">
            <div>
              <v-btn color="orange" class="white--text" @click.native="updateUrl(item)">
                Update <i class="fa fa-cog" aria-hidden="true"></i></v-btn>
            </div>
          </div>
        </template>
      </v-data-table>
      <v-layout v-layout align-center justify-center>
        <h5 style="margin-top: 10px;">Silahkan hubungi team marketing untuk konfirmasi aktivasi modul</h5>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import Tester from "@/components/irmacapital/Tester";

export default {
  name: "Sidompul",
  components: {Tester},
  data: () => ({
    search: "",
    dialog: false,
    dialogListMenu: false,
    valid: false,
    Rules: [(v) => !!v || "Please fill input"],
    title: "",
    searchKategori: "",
    kategoriData: {
      title: "",
      status: "",
      showHome: "",
      sort: "",
      menus: [],
    },
    url: "",
    dataDigipos: {},
    complex: {
      headers: [
        {
          text: "Server ID",
          value: "app_code",
        },
        {
          text: "URL Module (URL Webportal)",
          value: "url_module",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    },
    opsi: {
      search: "",
      itemsPerPage: 10,
      page: 1,
      sortBy: ["asc"],
    },
  }),

  watch: {
    opsi: {
      handler() {
        if(!this.soon) this.getSidompulData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("Sidompul", ["loading","sidompuls","totaldata","totalpage","soon","modal_aktivasi"]),
  },
  methods: {
    ...mapActions("Sidompul",["getSidompulData","openCloseModal","updateUrlModule"]),
    statusformat (value) {
      let a = 'Inactive'
      if (value === 1) {
        a = 'Active'
      }
      return a
    },
    formattime(time){
      return moment(time).format("YYYY-MM-DD")
    },
    updateUrl(data) {
      this.url = data.url_module
      this.dataDigipos = {...data}
      this.openCloseModal()
    },
    ajukan(){
      const request = {
        url_module: this.url
      }
      this.updateUrlModule(request)
    }
  },
};
</script>

<style lang="stylus" scoped>
.irma-image-priview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 150px;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 4px #ccc;
  box-shadow: 0 0 4px #ccc;
}

.imgupload-mask {
  width: 100%;
  max-width: 180px;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.iconupload {
  position: absolute;
  top: 0;
}

.quill {
  height: 300px;
  padding-bottom: 95px;
}

.imgslidelist {
  width: 32px;
  height: 32px;
}

.tdlist {
  padding: 4px !important;
}

.padr {
  padding-right: 10px !important;
}

.tdr {
  padding-left: 30px !important;
}
</style>